import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Paragraph, TextButton, IconChevronUpOutline, IconChevronDownOutline } from '@zillow/constellation';
import { getDTIMessageParts } from './DTICalculator.utils.js';

var MAX_GOOD_DTI_RATIO = 36;
var DTIMessage = function DTIMessage(_ref) {
  var value = _ref.value,
    defaultExpanded = _ref.defaultExpanded;
  var _useState = useState(defaultExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useMemo = useMemo(function () {
      return getDTIMessageParts(value, expanded);
    }, [value, expanded]),
    result = _useMemo.result,
    description = _useMemo.description;
  var onClick = function onClick(e) {
    e === null || e === void 0 || e.preventDefault();
    setExpanded(!expanded);
  };
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      margin: 'auto',
      'max-width': '400px'
    }
  }, /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement("strong", null, " ", result, " "), description), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: value > MAX_GOOD_DTI_RATIO ? 'block' : 'none',
      padding: '$spacing.xs 0 $spacing.sm',
      margin: 'auto',
      'text-align': 'center',
      '@media $md_gte': {
        display: 'none'
      }
    }
  }, /*#__PURE__*/React.createElement(TextButton, {
    onClick: onClick,
    "aria-expanded": expanded
  }, expanded ? /*#__PURE__*/React.createElement(React.Fragment, null, "Read less ", /*#__PURE__*/React.createElement(IconChevronUpOutline, {
    marginLeft: "xs"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, "Read more ", /*#__PURE__*/React.createElement(IconChevronDownOutline, {
    marginLeft: "xs"
  })))));
};
DTIMessage.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.number,
  defaultExpanded: PropTypes.bool
} : {};
var DTIMessage$1 = DTIMessage;

export { DTIMessage, DTIMessage$1 as default };
